import React from "react";

interface IBCNewLine {
  text?: string | any[];
  indentLines?: boolean
}

const BCNewLine = ({ ...props }: IBCNewLine) => {
  const linesList = props.text && typeof props.text === "string" && props.text.includes("\n") ? props.text.split("\n") : Array.isArray(props.text) ? props.text : [];
  return (
    <React.Fragment>
      {linesList.map((line, i) => <p  key={"kanban_newline_text" + i}>{props.indentLines ? " - " : ""}{line}</p>)}
    </React.Fragment>
  );
};

export default BCNewLine;